import React from 'react';
import { formatGap, gapDirection, gapWords, isNum } from '../format';
import { GapMark } from './GapChip';

/**
 * The one number a page leads with. Proportional figures, sans face, with
 * its meaning and sample on the same visual unit so it is never read alone.
 */
export default function HeroStat({ value, caption, footer }) {
  const direction = gapDirection(value);
  const has = isNum(value);
  return (
    <div className={`re-hero-stat re-hero-stat--${direction}`}>
      <p className="re-hero-stat__figure">
        {has ? <GapMark direction={direction} className="re-hero-stat__mark" /> : null}
        <span className="re-hero-stat__value">{has ? formatGap(value) : '—'}</span>
        <span className="re-hero-stat__words">{has ? gapWords(value) : 'not enough data yet'}</span>
      </p>
      {caption ? <p className="re-hero-stat__caption">{caption}</p> : null}
      {footer ? <div className="re-hero-stat__footer">{footer}</div> : null}
    </div>
  );
}
